// extracted by mini-css-extract-plugin
export default {"link":"navbar_link__riCdz","linkActive":"navbar_linkActive__94UHp"};